import './ContactUs.css';
import { useLanguage } from '../utils/LanguageContext';
import translations from './ContactUs.lang.json';

const ContactUs = () => {
  const { lang } = useLanguage(translations);

  return (
    <div className="contactUsTextContainer">
      <h2 className="contactUsTitle">{lang('contactUsTitle')}</h2>
      <div className="contactUsTextContent">
        <p>
          {/* TODO: translate email address */}
          {lang(`contactUsParagraph1`)} <a href="mailto:support@crecer.app">support@crecer.app</a>
        </p>
        <p>{lang(`contactUsParagraph2`)}</p>
        <p>{lang(`contactUsphoneNumber`)}</p>
      </div>
    </div>
  );
};

export default ContactUs;
